import styles from './ScreenSwitch.module.css';

const ScreenSwitch = () => {
  return (
    <div id="screenSwitch" className={styles.screenSwitch}></div>
  );
};

export default ScreenSwitch;